import { Button, Modal } from "react-bootstrap";
import styles from "./promotionCongrats.module.scss";
import { useNavigate } from "react-router-dom";

const PromotionCongratsPop = ({
  winningData,
  showPromotionCongrats,
  setShowPromotionCongrats,
  onFinish,
}) => {
  const navigate = useNavigate();

  const handledHide = () => {
    onFinish();
  };

  const redirectToWallet = () => {
    setShowPromotionCongrats(!showPromotionCongrats);
    navigate("/wallet");
  };

  return (
    <>
      <Modal
        show={showPromotionCongrats}
        // onHide={handledHide}
        backdrop={true}
        keyboard={true}
        centered
        scrollable
        className={`${styles.congratsPromotion} bottomPop`}
      >
        <div className="modalWrpper">
          <Modal.Body>
            <Button
              onClick={handledHide}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 5, right: 5 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>
            <div className="mx-auto" style={{ maxWidth: 300 }}>
              <div className="top text-center pt-4">
                {/* <img src={promotionImg} alt="" className="img-fluid" /> */}
              </div>

              <div className="text-center">
                <div className="py-2">
                  <h4 className="m-0 fw-bold text-white">
                    Congrats,{" "}
                    <span className="" style={{ color: "#2421f6" }}>
                      You Won!
                    </span>
                  </h4>
                </div>
                <div className="py-2">
                  <h2 className="m-0 fw-normal text-white">
                    {winningData?.prizeAmount} {winningData?.prizeCoin}
                  </h2>
                  <img
                    src={winningData?.prizeIcon}
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </div>
              {winningData?.prizeSymbol !== "btnc" ? (
                <div className=" text-center pb-3 text-white mt-3">
                  <Button
                    onClick={() => redirectToWallet()}
                    style={{ background: " #242AFC" }}
                    className="d-flex w-100 text-uppercase align-items-center justify-content-center fw-bold commonBtn border-0"
                  >
                    GO TO WALLET
                  </Button>
                </div>
              ) : (
                <div className=" text-center pb-3 text-white mt-3">
                  <Button
                    onClick={handledHide}
                    style={{ background: " #242AFC" }}
                    className="d-flex w-100 text-uppercase align-items-center justify-content-center fw-bold commonBtn border-0"
                  >
                    CLAIMED
                  </Button>
                </div>
              )}
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default PromotionCongratsPop;
